import { dataSelector } from '@nextiva/global-store';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const usePendo = (
  isUserLicensesWithAttributesLoading,
  nextivaCXFreeTrialAttributes,
  licenseFeatures
) => {
  const hasInitializedPendoRef = useRef(false);
  const { user, roles } = useSelector(dataSelector);
  const loginId = user ? user.loginId : null;
  const accountInfo = user ? user.accountInfo : null;

  let userRole = 'User';

  if (roles && roles[0]?.roleType === 'ROLE' && roles[0]?.userDefined) {
    userRole = 'User+';
  } else if (roles && roles[0]?.roleType === 'SUPER_ADMIN') {
    userRole = 'Admin';
  }

  useEffect(() => {
    if (
      hasInitializedPendoRef.current ||
      !loginId ||
      !accountInfo ||
      isUserLicensesWithAttributesLoading
    ) {
      return;
    }

    // This script installs and configures [Pendo](https://app.pendo.io) for authenticated users
    /* eslint-disable */
    (function (apiKey) {
      (function (p, e, n, d, o) {
        let v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push'](
                  [m].concat([].slice.call(arguments, 0))
                );
              };
          })(v[w]);
        y = e.createElement(n);
        y.async = !0;
        y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
      pendo.initialize({
        visitor: {
          id: loginId, // Required if user is logged in
          userRole,
          licenseFeatures
        },
        account: {
          id: window.location.hostname, // Highly recommended
          ...nextivaCXFreeTrialAttributes,
          ...accountInfo,
          ...nextivaCXFreeTrialAttributes,
        },
      });
    })('d4612175-6792-4105-58ca-25657df236e3');
    /* eslint-enable */

    hasInitializedPendoRef.current = true;
  }, [
    loginId,
    accountInfo,
    nextivaCXFreeTrialAttributes,
    isUserLicensesWithAttributesLoading,
    userRole,
    licenseFeatures,
  ]);
};
